import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAttendanceViewDetail } from '../../Thunks/NewAttendanceThunks';
import { AttendanceViewDetail } from "../../Types/HeyTraderTypes/Attendances/New/AttendanceViewDetail";

interface NewAttendanceViewDetailSliceState {
  loadingViewDetail: boolean;
  errorViewDetail: string | null;
  viewDetail: AttendanceViewDetail | null;
}

// set inital valus
const initialState: NewAttendanceViewDetailSliceState = {
  loadingViewDetail: false,
  errorViewDetail: '',
  viewDetail: null,
}

// set state value for api response
const newAttendanceViewDetailSlice = createSlice({
  name: 'newAttendanceViewDetail',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAttendanceViewDetail.rejected, (state, action) => {
        state.loadingViewDetail = false;
        state.errorViewDetail = action.error.message!;
      })

      .addCase(fetchAttendanceViewDetail.pending, state => {
        state.loadingViewDetail = true;
        state.errorViewDetail = null;
      })

      .addCase(fetchAttendanceViewDetail.fulfilled, (state, action: PayloadAction<AttendanceViewDetail>) => {
        state.loadingViewDetail = false;
        state.viewDetail = action.payload;
      })
  }
})

export default newAttendanceViewDetailSlice.reducer
